import { useEffect, useState } from "react";
import PageViewTables from "../../../components/PageView/PageViewTable/PageViewTables";
import Constants from "../../../utils/Constants";
import { Query } from "../../../types/GlobalInterfaces";

const CostsTable = ({
  parsedCosts,
  recordsLoading,
  year,
  month,
  type,
}: {
  parsedCosts: Array<any>;
  recordsLoading: boolean;
  year: number;
  month: number;
  type: "month" | "year";
}) => {
  const module = Constants.DEFAULT_MODULES[1];
  const [query, setQuery] = useState<Query>({
    Fields: [
      "RecordName",
      "Owner",
      ...Object.keys(Constants.MODELS_COST),
      "Created",
    ],
    Filters: [],
    Pagination: {
      Count: 25,
      Page: 1,
    },
  });

  const [sortedRecords, setSortedRecords] = useState<Array<any>>([]);

  useEffect(() => {
    setSortedRecords(parsedCosts);
  }, [parsedCosts]);

  if (!module) return null;

  return (
    <div key={`${year}-${month}`} className="table-responsive">
      <div className="w-100">
        <div className="w-100 d-flex">
          <h3 className="w-50">{`Usage ${
            type === "month"
              ? new Date(`${year}-${month}-01`).toLocaleString("default", {
                  month: "long",
                })
              : year
          } (USD)`}</h3>
        </div>
        <p className="h2">${getTotalCost(parsedCosts)}</p>
      </div>
      <PageViewTables
        currentModule={module}
        query={query}
        setQuery={setQuery}
        foundLayout={{
          id: "1",
          Fields: [
            "RecordName",
            "Owner",
            ...Object.keys(Constants.MODELS_COST),
            "Created",
          ],
          ModuleAPIName: "BrieCostTracker",
          Type: "Table",
        }}
        moduleAPIName={module?.APIName}
        selectableRows={false}
        records={sortedRecords}
        loading={recordsLoading}
        columnAdd={false}
        nameField="RecordName"
        includeHeader={false}
        updateSortBy={(sortBy: {
          Direction: "ASC" | "DESC";
          Field: string;
        }) => {
          setQuery((prev) => {
            return {
              ...prev,
              OrderBy: sortBy,
            };
          });

          setSortedRecords((prev) => {
            if (!sortBy) return parsedCosts;
            return prev.sort((a, b) => {
              if (sortBy?.Direction === "ASC") {
                return a[sortBy.Field].localeCompare(b[sortBy.Field]);
              } else {
                return b[sortBy.Field].localeCompare(a[sortBy.Field]);
              }
            });
          });
        }}
        isCustomTable
      />
    </div>
  );

  function getTotalCost(parsedCosts: Array<Record<string, number>>) {
    let modelKeys = Object.keys(Constants.MODELS_COST);
    modelKeys = modelKeys.map((key) => `${key}-graph`);

    return parsedCosts
      ?.map((cost) => {
        return modelKeys.reduce((acc, curr) => {
          return acc + cost[curr];
        }, 0);
      })
      .reduce((acc, curr) => {
        return acc + curr;
      }, 0)
      .toFixed(6);
  }
};

export default CostsTable;
